import React from 'react'
import { Link } from 'gatsby'
import { CtaArrow, SEO } from 'newComponents'
import Layout from '../../components/layout'
import ClosingCTAs from '../../components/ClosingCTAs'

import jiraHero from '../../images/integrations/Jira_Hero.png'
import integrations from '../../images/integrations/LaunchDarkly_Jira.png'
import intro from '../../images/integrations/IntroducingLaunchDarklyforJira.png'
import navy from '../../images/integrations/LaunchDarkly_Horizontal_Navy.png'
import dashboard from '../../images/integrations/LaunchDarklyDashboard.png'
import jira from '../../images/integrations/jira-software.svg'
import jiraDashboard from '../../images/integrations/JiraDashboard.png'
import jiraMarketplace from '../../images/integrations/JiraMarketplace.png'
import horizontalNavy from '../../images/integrations/LaunchDarkly_Horizontal_Navy.png'

const Jira = () => (
  <Layout>
    <SEO title="LaunchDarkly & Jira" description="" />
    <section className="section is-large bg-dark with-stars">
      <div className="container content">
        <div className="columns">
          <div className="column is-half">
            <h1 className="title">Power Up Your Collaboration</h1>
            <p>
              Jira and LaunchDarkly together give teams more visibility and great control over feature releases, so they
              can move faster with confidence.
            </p>
            <a
              className="button is-large is-primary"
              href="https://marketplace.atlassian.com/apps/1219142/launchdarkly-for-jira"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get the Jira integration
            </a>
          </div>
          <div className="column is-half">
            <img src={jiraHero} alt="jira screenshot" />
          </div>
        </div>
      </div>
    </section>
    <section className="section bg-gradient">
      <div className="container content columns columns--reverse">
        <div className="column">
          <h2>Giving Teams Context</h2>
          <p className="text-box">
            We all know that feeling when a new feature has just been released. Customer Success and Marketing want to
            understand what exactly Ops turned on, and Ops wants to understand what Dev pushed over to them.
          </p>
          <p>
            <strong>What if there was a single place where all teams had visibility into new features?</strong>
          </p>
        </div>
        <div className="column">
          <div>
            <img src={integrations} alt="custom properties" />
          </div>
        </div>
      </div>
    </section>
    <section className="section is-large bg-gradient">
      <div className="container content columns is-centered">
        <div className="column is-8">
          <h2 className="has-text-centered">Introducing LaunchDarkly for Jira</h2>
          <p className="text-box">
            Teams already use Jira and LaunchDarkly to manage their product release processes—now they can use them
            together. With feature flagging information in Jira, teams can quickly and easily access critical
            information around a feature release from a single place, enabling them to work more efficiently and
            collaboratively.
          </p>
          <p className="text-box">
            From Jira, teams have visibility into whether a feature flag has been turned on and what percentage of
            customers are experiencing it. Team members can also drill into an issue and see what feature flags are
            associated with it.
          </p>
          <p className="text-box">
            With better visibility and greater control over all aspects of a feature release, teams can be more
            confident they’re focusing on the right things and move faster.
          </p>
          <p className="has-text-centered">
            <img src={intro} alt="" width="600" />
          </p>
        </div>
      </div>
    </section>
    <section className="section is-large bg-gradient">
      <div className="container content columns">
        <div className="column">
          <h2>
            <div>
              <img src={navy} alt="LaunchDarkly" width="180" />
            </div>
            Feature Management
          </h2>
          <p className="text-box">
            LaunchDarkly is the feature management platform software teams use to build better software, faster. Leading
            teams use feature flags to separate code deployments from feature releases. And with LaunchDarkly these
            teams control their entire feature lifecycles from concept to launch to value.
          </p>
          <a href="/start-trial/" className="cta">
            Start a LaunchDarkly Trial
            <CtaArrow />
          </a>
        </div>
        <div className="column">
          <div className="largerimage">
            <img src={dashboard} alt="dashboard" />
          </div>
        </div>
      </div>
    </section>
    <section className="section is-large bg-gradient">
      <div className="container content columns columns--reverse">
        <div className="column">
          <h2>
            <div>
              <img src={jira} alt="Jira Software" width="180" />
            </div>
            Issue &amp; Project Management
          </h2>
          <p className="text-box">
            Jira is the #1 software development tool used by agile teams to plan, track, and release great software.
            Built for all team members, Jira enables collaboration by providing everyone with visibility into important
            information for planning and coordinating projects, tracking progress, and reporting results in real-time.
          </p>
          <a href="https://www.atlassian.com/software/jira" className="cta" target="_blank" rel="noopener noreferrer">
            Start a Jira Trial
            <CtaArrow />
          </a>
        </div>
        <div className="column">
          <div className="largerimage">
            <img src={jiraDashboard} alt="jira Dashboard" />
          </div>
        </div>
      </div>
    </section>
    <div className="clipped-container">
      <section className="section is-large bg-dark bg-static-stars is-clipped">
        <div className="container content">
          <div className="columns">
            <div className="column">
              <h2 className="title">Ready to Get Started?</h2>
              <p>
                Streamline communication across teams by bringing valuable context about feature flags into Jira issues.
                Get the{' '}
                <a
                  href="https://marketplace.atlassian.com/apps/1219142/launchdarkly-for-jira"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LaunchDarkly for Jira integration
                </a>{' '}
                in the Jira Marketplace, and read our{' '}
                <a href="https://docs.launchdarkly.com/docs/jira" target="_blank" rel="noopener noreferrer">
                  docs
                </a>{' '}
                for instructions on how to set up the integration.
              </p>
              <a
                className="button is-large is-primary after-paragraph"
                href="https://marketplace.atlassian.com/apps/1219142/launchdarkly-for-jira"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get the Jira integration
              </a>
            </div>
            <div className="column has-text-centered-tablet">
              <img src={jiraMarketplace} alt="jira marketplace" style={{ margin: '-3rem 0', width: '36rem' }} />
            </div>
          </div>
        </div>
      </section>
    </div>
    <section className="section is-large bg-gradient">
      <div className="container content columns is-centered">
        <div className="column is-8">
          <div className="section-title">
            <h2 className="has-text-centered">Want to Learn More About LaunchDarkly and Jira?</h2>
          </div>
          <div className="columns is-variable is-8">
            <div className="column">
              <h4>
                <img src={navy} alt="LaunchDarkly" width="180" />
              </h4>
              <p>
                See how LaunchDarkly works in your stack &ndash; it only takes a few minutes to set up your first
                feature flag.
              </p>
              <Link to="/start-trial/" className="cta">
                Start a Trial
                <CtaArrow />
              </Link>
            </div>
            <div className="column">
              <h4>
                <img src={jira} alt="Jira Software" width="180" style={{ margin: '0.6rem 0' }} />
              </h4>
              <p>See what your team can accomplish with better visibility into project timelines and event outcomes.</p>
              <a
                href="https://www.atlassian.com/software/jira"
                className="cta"
                target="_blank"
                rel="noopener noreferrer"
              >
                Start a Trial
                <CtaArrow />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <ClosingCTAs />
  </Layout>
)

export default Jira
